<template>

    <div>

        <p class="sd-game-info text-center" v-if="sdgame">Season: {{ sdgame.season }} <span class="double-pipe mx-4">||</span> Game: {{ sdgame.game }}</p>

        <v-simple-table dense>

            <thead>
            <tr>
                <th class="table-hdr">Week</th>
                <th class="table-hdr">Pick</th>
                <th class="table-hdr">Result</th>
                <th class="table-hdr d-none d-md-table-cell"># Survivors</th>
                <th class="table-hdr"></th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="week in gameWeeks" :key="week.id">
                <td>{{ week.play_week_num }}</td>
                <td v-if="isAliveWeek(week)" v-html="getTeamPicked(week.id)"></td>
                <td v-if="isAliveWeek(week)">{{ getResult(week) }}</td>
                <td class="text-left" v-if="!isAliveWeek(week)" colspan="2">You're dead!</td>
                <td class="d-none d-md-table-cell">{{ getNumAliveByWeek(week.id) }}</td>
                <td><v-btn color="secondary" elevation="2" plain x-small @click="gotoDetails(week.id)" v-if="week.scores_in">Details</v-btn></td>
            </tr>
            </tbody>

        </v-simple-table>

    </div>

</template>

<script>

  import {mapGetters} from "vuex";

  export default {
    name: "SuddenDeathTable",
    props: [
      'sdgame',
      'isCurrentGame',
    ],
    data: () => ({
      pickedTeam: null,
    }),
    computed: {
      ...mapGetters([
        'user',
        'weeks',
        'weekInfo',
        'weekGames'
      ]),
      gameWeeks() {
        if (this.weeks && this.weekInfo) {
          return this.weeks.filter(week => week.sd_game_id === this.sdgame.id);
        }
      },
      userPicks() {
        return this.sdgame.picks.filter(pick => pick.user_id === this.user.id);
      },
    },
    methods: {
      isAliveWeek(week) {
        //either: first week of game OR prev week pick was a winner
        if (week.sd_round === 1) {
          return true;
        } else {
          if (!this.userPicks) {
            return false;
          } else {
            let prevWeek = this.gameWeeks.filter(w => w.sd_game_id == week.sd_game_id && w.sd_round == week.sd_round - 1)[0];
            let prev = this.sdgame.picks.filter(pick => pick.user_id === this.user.id && pick.week_id === prevWeek.id)[0];
            if (!prev || prev.result !== 'won') {
              return false;
            } else {
              return true;
            }
          }
        }
      },
      getTeamPicked(week_id) {
        if (this.weeks && this.weekInfo && this.userPicks) {
          let pick = this.userPicks.filter(pick => pick.week_id === week_id).map(pickedPick => pickedPick.team_picked)[0];
          return pick ? pick : 'No Team Picked';
        }
      },
      getResult(week) {
        let rtn = '';
        if (this.weeks && this.weekInfo && this.userPicks) {
          let pick = this.userPicks.filter(pick => pick.week_id === week.id)[0];
          if (pick) {
            if (pick.result === null) {
              rtn = 'tbd';
            } else {
              rtn = pick.result;
            } 
          }
        }
        return rtn;
      },
      getNumAliveByWeek(week_id) {
        let games = this.sdgame.picks.filter( pick => pick.week_id === week_id);
        if (games.length) {
          let winners = games.filter(pick => pick.week_id === week_id && pick.result === 'won');
          let losers = games.filter(pick => pick.week_id === week_id && pick.result === 'lost');
          let num = winners.length;
          if (winners.length > 0 || losers.length > 0) {
            if (num > 1) {
              return num;
            } else if (num === 1) {
              let winner = winners[0].user.username;
              return winner + ' is the winner!';
            } else {
              return 'No winner!'
            }
          }
        }
      },
      gotoDetails(weekId) {
        this.$router.push({name: 'Sudden Death Week', params: { weekId }});
      }
    },

  }
</script>

<style scoped>

    .sd-game-info {
        font-style: italic;
        font-weight: light;
        color: var(--v-secondary-base);
    }

    .v-select__selections input {
        font-size: 0.5rem;
    }

    .table-hdr {
        background: var(--v-primary-base);
        padding-top: 1rem !important;
        padding-bottom: 1rem !important;
    }

</style>
